module.exports = __webpack_public_path__ + "img/kayamot.2f0e87ce.svg";